<template>
  <div class="registration-complete">
    <h1 class="section-title">
      {{ $t("thanks for registering") }}
    </h1>
    <div class="registered-text">
      <p>{{ $t("follow instructions from registration mail") }}</p>
      <p>
        {{ $t("Go back to:") }}
        <van-button
          type="primary"
          :to="{ name: 'Home' }"
          icon="wap-home-o"
          style="margin-left:10px"
          >{{ $t("home") }}
        </van-button>
      </p>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "RegisteredThanks",
  methods: {
    ...mapMutations("setting", ["SET_PAGE_TITLE"])
  },
  created() {
    this.SET_PAGE_TITLE(this.$t("thanks for registering"));
  }
};
</script>
<style scoped>
.registered-text {
  padding: 16px;
}
.registered-text p {
  margin-top: 32px;
}
</style>
